export default {
  title: "Marketplace Collection",
  subtitle: "",
  path: "marketplace_overview",
  paragraph: "",
  request: {}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/MarketplaceCollection/MarketplaceOverview.js